module.exports = __webpack_public_path__ + "account/img/report.106ec840.png";